export const StepHeader = ({ title, subtitle }: { title: string; subtitle?: string }) => (
  <div>
    <h3 className="text-lg font-semibold mb-1">{title}</h3>
    {subtitle && <p className="text-sm text-gray-600">{subtitle}</p>}
  </div>
);

export const StatusBadge = ({
  status,
  label,
}: {
  status: "passed" | "running" | "failed";
  label: string;
}) => {
  const variants = {
    passed: "bg-green-100 text-green-800",
    running: "bg-blue-100 text-blue-800",
    failed: "bg-red-100 text-red-800",
  };

  const icons = {
    passed: "✓",
    running: "⏳",
    failed: "✗",
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${variants[status]}`}
    >
      {icons[status]} {label}
    </span>
  );
};

export const ValidationJobCard = ({
  title,
  description,
  result,
  status,
  details,
}: {
  title: string;
  description: string;
  result: string;
  status: "passed" | "running" | "failed";
  details?: string;
}) => (
  <div className="border rounded-lg p-4">
    <div className="flex items-center justify-between mb-2">
      <h4 className="font-medium">{title}</h4>
      <StatusBadge status={status} label={status.toUpperCase()} />
    </div>
    <p className="text-sm text-gray-600 mb-1">{description}</p>
    <p className="text-sm text-gray-700">{result}</p>
    {details && <p className="text-sm text-gray-600 mt-2">{details}</p>}
  </div>
);

export const SummaryItem = ({ label, value }: { label: string; value: string | number }) => (
  <div className="flex justify-between">
    <span className="text-gray-600">• {label}:</span>
    <span className="font-medium">{value}</span>
  </div>
);

export const StatCard = ({
  icon,
  label,
  value,
  color = "gray",
}: {
  icon?: React.ReactNode;
  label: string;
  value: string | number;
  color?: "gray" | "blue" | "green" | "red";
}) => {
  const colorClasses = {
    gray: "bg-gray-600",
    blue: "bg-blue-600",
    green: "bg-green-600",
    red: "bg-red-600",
  };

  return (
    <div className="text-center p-4 border rounded-lg">
      <div className="flex items-center justify-center gap-2 mb-2">
        {icon || <div className={`w-4 h-4 ${colorClasses[color]} rounded`}></div>}
        <span className="text-sm font-medium text-gray-600">{label}</span>
      </div>
      <div className="text-2xl font-bold">{value}</div>
    </div>
  );
};
